import { CitationGeneratorAction, CitationGeneratorStates, CitationSourceEnum } from '../types';
import * as actionNames from '../types/names';

const initialState: CitationGeneratorStates = {
  isEditFormOpen: false,
  citations: [],
  searchType: CitationSourceEnum.WEBSITE,
  pageNo: 1,
  isSearchMode: false,
};

export function citationGenerationReducer(
  state = initialState,
  action: CitationGeneratorAction
): CitationGeneratorStates {
  switch (action.type) {
    case actionNames.EDIT_MODAL_TOGGLE: {
      const { editFormDefaultValuse, open, index } = action.payload;
      const newState = open
        ? {
            isEditFormOpen: open,
            editFormDefaultValuse: editFormDefaultValuse || null,
            indexOfCitaionToBeEdit: typeof index === 'number' ? index : null,
          }
        : {
            isEditFormOpen: open,
            editFormDefaultValuse: null,
            indexOfCitaionToBeEdit: null,
          };
      return {
        ...state,
        ...newState,
      };
    }

    case actionNames.ADD_CITATIONS_TO_SEARCH_RESULT: {
      if (state.pageNo > 1) return { ...state, citations: [...state.citations, ...action.payload] };
      return { ...state, citations: [...action.payload] };
    }
    case actionNames.CHANGED_CITATION_SOURCE:
      return { ...state, searchType: action.payload };
    case actionNames.OpenInplaceCreateForm:
      return { ...state, isInplaceCreateFormOpenedFromCowriter: action.payload };
    case actionNames.SetSearchQuery:
      return { ...state, searchQuery: action.payload };
    case actionNames.SetLoadingResults:
      return { ...state, isLoadingResults: action.payload };
    case actionNames.IncrementPageNo: {
      if (state.isLoadingResults) return state;
      return { ...state, pageNo: action.payload ? 1 : state.pageNo + 1 };
    }
    case actionNames.SetIsLastPage:
      return { ...state, isLastPage: action.payload };
    case actionNames.USER_SEARCHED_QUERY:
      return { ...state, bibSearchQuery: action.payload };
    case actionNames.StartSearchMode:
      return { ...state, isSearchMode: true };
    case actionNames.StopSearchMode:
      return { ...state, isSearchMode: false };
    case actionNames.RestoreToDefaultState:
      return {
        ...state,
        isEditFormOpen: false,
        citations: [],
        bibSearchQuery: '',
        isLastPage: false,
        pageNo: 1,
        isSearchMode: false,
      };

    default: {
      return state;
    }
  }
}
